import { FC, ReactNode } from 'react'
import { InputTextType } from '../../../../../common/InputType'
import PhoneLabelRow from './PhoneLabelRow'
import DefaultLabelPopup from './DefaultLabelPopup'

type Props = {
  rowIndex: number
  phoneInput: InputTextType
  labelInput: InputTextType
  showLabelListIndex: number | null
  defaultLabelList: string[]
  onClosePopup: () => void
  onSelectLabel: (label: string) => void
  setRowRef: (rowIndex: number) => (el: HTMLDivElement | null) => void
  setLabelInputRef: (rowIndex: number) => (el: HTMLInputElement | null) => void
  onClickLabelInput: () => void

  onFocusLabelInput: () => void
  onBlurLabelInput: () => void
  onPopupMouseDown: () => void

  removeSlot?: ReactNode
  popupClassName?: string
}

const PhoneLabelLine: FC<Props> = (props) => {
  const {
    rowIndex,
    phoneInput,
    labelInput,
    showLabelListIndex,
    defaultLabelList,
    onClosePopup,
    onSelectLabel,
    setRowRef,
    setLabelInputRef,
    onClickLabelInput,
    onFocusLabelInput,
    onBlurLabelInput,
    onPopupMouseDown,
    removeSlot,
    popupClassName,
  } = props

  const popupAnchorClassName =
    rowIndex === 0
      ? 'phoneLabelPopupAnchor phoneLabelPopupAnchor--firstRow'
      : 'phoneLabelPopupAnchor'

  return (
    <div className="phoneLabelRowWrap" ref={setRowRef(rowIndex)}>
      <PhoneLabelRow
        first={phoneInput}
        second={labelInput}
        secondRef={setLabelInputRef(rowIndex)}
        onClickSecond={onClickLabelInput}
        onFocusSecond={onFocusLabelInput}
        onBlurSecond={onBlurLabelInput}
      />

      <div
        className={popupAnchorClassName}
        onMouseDown={(e) => {
          e.preventDefault()
          onPopupMouseDown()
        }}
      >
        {removeSlot ? (
          removeSlot
        ) : (
          <span
            className="phoneLabelRowRemove phoneLabelRowRemove--dummy"
            aria-hidden="true"
          />
        )}

        <DefaultLabelPopup
          isOpen={showLabelListIndex === rowIndex}
          defaultLabelList={defaultLabelList}
          onClose={onClosePopup}
          onSelect={onSelectLabel}
          className={popupClassName}
        />
      </div>
    </div>
  )
}

export default PhoneLabelLine
